// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__o4sUR","container":"styles_container__6e8Up","title":"styles_title__mxoxc","text":"styles_text__hIrC3","textColor":"styles_textColor__nsKjK"};